import React from "react";
import ArticleTemplate from "../../../components/ArticleTemplate";

const contentHtml = `
<h1>Hello from Markdown</h1>
<p>This is a <strong>test article</strong> generated by the script.</p>
<ul>
<li>It has a list</li>
<li>Some <strong>bold</strong> text</li>
<li>And a <a href="https://security.extropy.io">link</a></li>
</ul>

`;

const TestArticle = () => {
  return (
    <ArticleTemplate
      title="Test Article From Markdown"
      subtitle="This is a test generated via md-to-article.cjs"
      author="Test Author"
      date="November 20th, 2025"
      readingTime="3 min read"
      tags={["Article","Test","Security"]}
      canonicalUrl="https://security.extropy.io/articles/test-article"
      contentHtml={contentHtml}
    />
  );
};

export default TestArticle;
